<!-- LEGACY WRAPPER — Migrado a <script setup>. Usar ModalBase en modules. Envoltorio transitorio: NO agregar responsabilidades. -->
<template>
    <modal
        :name="name"
        transition="pop-out"
        :width="800"
        height="auto"
        scrollable
        :id="name"
        :adaptive="true"
        @before-open="emitOpened"
        @closed="emitClosed"
    >
        <div class="tw:bg-white tw:rounded-xl tw:shadow-lg tw:border tw:border-gray-200 tw:overflow-hidden">
            <div class="tw:border-b tw:border-gray-200 tw:px-6 tw:py-4">
                <div class="tw:flex tw:items-start tw:justify-between">
                    <div class="tw:flex-1">
                        <h2 class="tw:text-2xl tw:font-semibold tw:text-gray-900">{{ title }}</h2>
                        <p v-if="subtitle" class="tw:text-sm tw:text-gray-500 tw:mt-1">{{ subtitle }}</p>
                    </div>
                    <button type="button" class="tw:text-gray-400 tw:hover:text-gray-600 tw:transition-colors tw:shrink-0 tw:ml-4" @click.prevent="close()">
                        <span class="tw:text-3xl tw:leading-none">×</span>
                    </button>
                </div>
            </div>
            <div class="tw:px-6 tw:py-4">
                <slot></slot>
            </div>
            <div v-if="$slots.footer" class="tw:bg-gray-50 tw:border-t tw:border-gray-200 tw:px-6 tw:py-4 tw:text-right">
                <slot name="footer"></slot>
            </div>
        </div>
    </modal>
</template>

<script setup>
// LEGACY WRAPPER — migrado a <script setup>. Usar ModalBase en modules. Envoltorio transitorio: NO agregar responsabilidades.
    import { getCurrentInstance } from 'vue';

    const props = defineProps({
        name: String,
        title: String,
        subtitle: String
    });

    const emit = defineEmits(['close', 'opened', 'closed']);

    const instance = getCurrentInstance();

    function close() {
        instance?.proxy?.$modal?.hide(props.name);
        emit('close');
    }

    function emitOpened() {
        emit('opened');
    }

    // vue-js-modal emite `closed` cuando el modal se cierra por CUALQUIER vía
    // (botón X, ESC, clic exterior, $modal.hide). Se propaga para que el
    // consumidor pueda reaccionar a cierres que no pasan por close().
    function emitClosed(e) {
        emit('closed', e);
    }
</script>
<style scoped>
    :deep(.v--modal) {
        border-radius: 0.75rem !important;
    }
</style>